/*!
 * Copyright (c) HoaDev and contributors. All rights reserved.
 * More licensed under license file.
 * Created by HoaDev, 10/06/2022
 */

const PREFIX_URL = "/config";

interface MenuItemInterface {
  key: string;
  label: string;
  onClick?: () => void;
}

// Tạo list menu con demo
export const LIST_MENU: MenuItemInterface[] = [
  {
    key: "/",
    label: "Home App",
  },
  {
    key: PREFIX_URL,
    label: "Demo 1",
  },
  {
    key: PREFIX_URL + "/list",
    label: "List Demo 1",
  },
  {
    key: "/auth/login",
    label: "Login",
  },
];
